import React from 'react';
import styles from './SpeakersTab.module.scss';
import { Icon } from '../../../../components/Icon';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

const SpeakersTab = ({ mode, currentMode, onSelect }) => {
  const handleSelect = () => {
    onSelect(mode);
  };

  const { t } = useTranslation();

  return (
    <div className={cx(styles.wrapper, { [styles.active]: mode === currentMode })} onClick={handleSelect}>
      <Icon src={mode ? 'multiply_speakers' : 'one_speaker'} className={styles.icon} />
      <span className={styles.text}>
        {mode ? t('subtitles.editor.speakers_mode.multiple_speakers') : t('subtitles.editor.speakers_mode.one_speaker')}
      </span>
    </div>
  );
};

export default SpeakersTab;
